<template>
  <a class="case-card" @click="zoomImage($event)">
    <div class="transition-box">
      <div class="case-card__image lazy" :style="{'background-image': currentImage}"></div>
    </div>

    <div class="case-card__text">
      <h4 class="case-card__project-type">{{ type }}</h4>
      <h2 class="case-card__title">{{ title }}</h2>
    </div>

    <ZoomImage
      :imageToZoom="currentImage"
      :isInstantiated="initClone"
      :initPosition="clonePosition"
      :targetUrl="url"
    />
  </a>
</template>


<script>
import { mapState } from "vuex";
import LazyLoad from "vanilla-lazyload";
import ZoomImage from "@/components/ZoomImage.vue";

export default {
  name: "CaseCard",
  props: {
    id: Number
  },
  components: {
    ZoomImage
  },
  data() {
    return {
      // Not in use when the Lazy load library is used
      // bgImage: 'center / cover no-repeat url(' + this.image + ')'
      initClone: false,
      clonePosition: {}
    };
  },
  computed: mapState({
    currentCase: function(state) {
      return state.data.cases.find(item => item.id === this.id);
    },
    imageLandscape: function() {
      return this.currentCase.info.imageLandscape;
    },
    imagePortrait: function() {
      return this.currentCase.info.imagePortrait;
    },
    type: function() {
      return this.currentCase.info.type;
    },
    title: function() {
      return this.currentCase.info.title;
    },
    url: function() {
      return this.currentCase.info.url;
    },

    smallScreen: function(state) {
      return state.globals.screenWidth < 1024;
    },
    currentImage: function() {
      return `url(${
        this.smallScreen ? this.imagePortrait : this.imageLandscape
      })`;
    }
  }),
  methods: {
    zoomImage() {
      const orgElement = this.$el.firstChild;
      const orgPos = orgElement.getBoundingClientRect();

      this.initClone = true;

      this.clonePosition = {
        top: `${orgPos.y}px`,
        left: `${orgPos.x}px`,
        width: `${orgPos.width}px`,
        height: `${orgPos.height}px`
      };
    },
    scrollToTop() {
      const smoothScrollBar =
        this.$root.$children[0].$children[1].$children[0].scrollBar || null;

      if (smoothScrollBar) {
        smoothScrollBar.scrollTo(0, 0, 0);
      } else window.scrollTo(0, 0);
    }
  },
  mounted() {
    new LazyLoad({
      elements_selector: ".lazy"
    });
  }
};
</script>


<style lang="scss">
@import "../scss/globals.scss";

.case-card {
  display: flex;
  flex-direction: column;
  width: 100%;
  box-sizing: border-box;
  color: currentColor;

  cursor: pointer;

  .transition-box {
    height: 100%;
    overflow: hidden;
  }

  &__image {
    transition: transform 2s linear;
    transform: scale(1.00001);
    width: 100%;
    height: 100%;
    padding-top: 120%;

    background: center / cover no-repeat;
    
    @media screen and (min-width: 377px) {
      padding-top: 50%;
    }
  }

  &__project-type {
    @include typeset(trumpet);

    margin-top: $margin1-4;
    opacity: 0.5;
  }

  &__title {
    @include typeset(body-large);
    font-family: $font-expanded;
    text-transform: capitalize;

    padding-bottom: 1px;
  }
}
</style>
